{
	"online": "online",
	"offline": "offline",
	"invalid": "Status inválido"
}
